import axios from "../axiosinterceptor/LabAxiosInterceptor"
axios.defaults.withCredentials = true;

export const labUserLogin = (formBody) => axios.post('labuser-login/', formBody)

export const allCoustomers = () => axios.get("admin-get-all-customers-for-lab/")

export const getAllOrders = (page = 1, search = "") =>
  axios.get(`lab-get-all-orders/`, {
    params: {
      page,
      search,
    },
  });

export const fetchOrderModalData = (orderId) =>axios.get(`lab-order-modal-data/${orderId}/`);

export const rejectPouchItem = (formBody) => axios.post(`reject-pouch-item/`, formBody)

export const labSampleCollect = (formBody) => axios.post('lab-sample-collect/', formBody)

export const labAccessionStart = (formBody) => axios.post('lab-start-accession-of-patient/', formBody)

export const password_change = (email, old_pass, new_pass) => axios.post('lab-change-password/', { email, old_password: old_pass, new_password: new_pass, })

export const fetchAllOrders = (userId) =>
    axios.get(`admin-get-all-orders/`, { params: { user_id: userId } });


export const getOrderItemsByCustomer = (customerId) =>
    axios.get(`admin-get-order-items/${customerId}/`);

export const getCustomerDetails = (customerId) =>
    axios.get(`admin-customer0details-${customerId}/`);

export const createOrder = (payload) =>
    axios.post(`admin-create-order/`, payload);


export const cancelOrder = (orderId, reason) =>
    axios.post(`admin-cancel-order/${orderId}/`, {
        status: "cancelled",
        reason,
    });

export const changeLabStatus = (orderId, status) =>
    axios.post(`lab-status-change-by-lab-console/`, {
        id: orderId,
        status,
    });

export const verifyPayment = (razorpay_payment_id, razorpay_order_id, razorpay_signature) =>
    axios.post(`verify-payment/`, {
        razorpay_payment_id,
        razorpay_order_id,
        razorpay_signature,
    });